export default __webpack_public_path__ + "static/media/bg.b6b1a95b.png";